export default {
  props: {
    benefits: Array | Object,
    from: String,
  },
};
